import { queryOptions } from '@tanstack/react-query';

import { getCoinInfo } from '@api/token/coinInfo';

import { getTokenPriceHistory, type TokenPeriod } from './tokenPriceHistory';

export const tokensQueries = {
  all: () => ['tokens'] as const,
  priceHistory: (idOrSlug: number | string, period: TokenPeriod) =>
    queryOptions({
      queryKey: [...tokensQueries.all(), 'price-history', idOrSlug, period] as const,
      queryFn: () => {
        return getTokenPriceHistory(idOrSlug, period);
      },
    }),
  coinInfo: (idOrSlug: number | string) =>
    queryOptions({
      queryKey: [...tokensQueries.all(), 'coinInfo', idOrSlug],
      queryFn: () => getCoinInfo(idOrSlug),
    }),
};
